module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row efw"
  }, [_c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('h5', [_vm._v(_vm._s(_vm.caption)), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.required),
      expression: "required"
    }]
  }, [_vm._v("*")])]), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17c67e10","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/edit-full-width.vue
// module id = 242
// module chunks = 1